export default __webpack_public_path__ + "static/media/geisha.82989f7b.jpg";